import classNames from 'classnames'

import style from './style.scss'

type Props = {
  characterBreakpoints?: {
    three?: number
    two?: number
  }
  children: string
  className?: string
}

type Headline = 'headlineOne' | 'headlineTwo' | 'headlineThree'

AdjustableHeadline.defaultProps = {
  characterBreakpoints: {},
  className: '',
}

function AdjustableHeadline(props: Props) {
  const { characterBreakpoints = {}, children, className } = props
  const { two, three } = characterBreakpoints
  const length = children.length
  let headlineStyle: Headline = 'headlineOne'

  if (three && length >= three) {
    headlineStyle = 'headlineThree'
  } else if (two && length >= two) {
    headlineStyle = 'headlineTwo'
  }

  return (
    <h1 className={classNames(style[headlineStyle], className)}>{children}</h1>
  )
}

export default AdjustableHeadline
